import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './store';

import { BrowserRouter as Router } from 'react-router-dom'; // Router 추가
import { initGA } from './utils/analytics';

// GA 초기화
initGA();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);
